// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2qKOw","subheader":"ReorderModal_subheader__3j81D","listWrap":"ReorderModal_listWrap__1Qh0M"};